import React from "react";
import { useNavigate } from "react-router-dom";
import { LoginForm } from "../components/LoginForm";

export const Login: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = () => {
    navigate("/dashboard");
  };

  return (
    <LoginForm onSuccess={handleLoginSuccess} />
  );
};
